import { SEO, FAQ } from "../../data/startPageContent";
import { CM } from "../../data/forPageContent";

const BASE_URL = "https://clinikit.co.il";

const faqBlock = (items) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: items.map((f) => ({
    "@type": "Question",
    name: f.question,
    acceptedAnswer: { "@type": "Answer", text: f.answer },
  })),
});

const crumbBlock = (name, url) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    { "@type": "ListItem", position: 1, name: "דף הבית", item: `${BASE_URL}/` },
    { "@type": "ListItem", position: 2, name, item: url },
  ],
});

/** JSON-LD for /for/:slug — SoftwareApplication (+audience), FAQPage (shared /start FAQ), BreadcrumbList. */
export const buildForJsonLd = (pageData) => {
  const url = `${BASE_URL}/for/${pageData.slug}`;
  return [
    {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      name: SEO.appName,
      alternateName: "קליניקיט",
      url,
      applicationCategory: "BusinessApplication",
      applicationSubCategory: "Healthcare Practice Management Software",
      operatingSystem: "Web Browser",
      inLanguage: "he",
      description: pageData.metaDescription,
      offers: [
        { "@type": "Offer", name: "30 יום ניסיון חינם", price: SEO.trialPrice, priceCurrency: "ILS" },
        { "@type": "Offer", name: "מסלול מקצועי", price: SEO.monthlyPrice, priceCurrency: "ILS" },
      ],
      audience: { "@type": "Audience", audienceType: pageData.professionShort },
    },
    faqBlock(FAQ),
    crumbBlock(pageData.profession, url),
  ];
};

/** JSON-LD for /for/clinic-management — own FAQ (CM.faq). */
export const buildClinicManagementJsonLd = () => {
  const url = `${BASE_URL}${CM.seo.path}`;
  return [
    {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      name: SEO.appName,
      alternateName: "קליניקיט",
      url,
      applicationCategory: "BusinessApplication",
      applicationSubCategory: "Healthcare Practice Management Software",
      operatingSystem: "Web Browser",
      inLanguage: "he",
      description: CM.seo.jsonLdDescription,
      offers: [
        { "@type": "Offer", name: "30 יום ניסיון חינם", price: SEO.trialPrice, priceCurrency: "ILS" },
        { "@type": "Offer", name: "מסלול מקצועי", price: SEO.monthlyPrice, priceCurrency: "ILS" },
      ],
    },
    faqBlock(CM.faq),
    crumbBlock(CM.seo.breadcrumb, url),
  ];
};
